export const menuItems = [
	{
		labelDictionaryKey: "HeaderTextPlayGames",
		linkDictionaryKey: "HeaderUrlPlayGames",
		attrDictionaryKey: "HeaderTitleAttributePlayGames",
		isNew: true,
		useRouter: true,
		eventID: null,
		forceExternal: true,
	},
	{
		labelDictionaryKey: "HeaderTextCrosswordSolver",
		linkDictionaryKey: "HeaderUrlCrosswordSolver",
		attrDictionaryKey: "HeaderTitleAttributeCrosswordSolver",
		isNew: true,
		cssClass: "has-hint",
		useRouter: true,
		eventID: null,
	},
	{
		labelDictionaryKey: "HeaderSection2Text",
		linkDictionaryKey: "HeaderSection2Url",
		attrDictionaryKey: "HeaderSection2TitleAttribute",
		cssClass: "has-hint",
		useRouter: true,
		navLink: true,
		eventID: null,
	},
	{
		labelDictionaryKey: "HeaderSection3Text",
		linkDictionaryKey: null,
		attrDictionaryKey: "HeaderSection3TitleAttribute",
		cssClass: "has-hint",
		navLink: true,
		eventID: null,
		submenu: [
			[
				{
					labelDictionaryKey: "HeaderSection3Subsection1Text",
					linkDictionaryKey: "HeaderSection3Subsection1Url",
					attrDictionaryKey:
						"HeaderSection3Subsection1TitleAttribute",
					eventID: null,
				},
				{
					labelDictionaryKey: "HeaderSection3Subsection2Text",
					linkDictionaryKey: "HeaderSection3Subsection2Url",
					attrDictionaryKey:
						"HeaderSection3Subsection2TitleAttribute",
					eventID: null,
				},
				{
					labelDictionaryKey: "HeaderSection1Text",
					linkDictionaryKey: "HeaderSection1Url",
					attrDictionaryKey: "HeaderSection1TitleAttribute",
					useRouter: true,
					eventID: null,
				},
				{
					labelDictionaryKey: "HeaderTextWordleAnswers",
					linkDictionaryKey: "HeaderUrlWordleAnswers",
					attrDictionaryKey: "HeaderTitleAttributeWordleAnswers",
					useRouter: true,
					eventID: null,
				},
				{
					labelDictionaryKey: "HeaderSection3Subsection3Text",
					linkDictionaryKey: "HeaderSection3Subsection3Url",
					attrDictionaryKey:
						"HeaderSection3Subsection3TitleAttribute",
					eventID: null,
				},
				{
					labelDictionaryKey: "HeaderSection3Subsection4Text",
					linkDictionaryKey: "HeaderSection3Subsection4Url",
					attrDictionaryKey:
						"HeaderSection3Subsection4TitleAttribute",
					eventID: null,
				},
			],
			[
				{
					labelDictionaryKey: "HeaderSection3Subsection5Text",
					linkDictionaryKey: "HeaderSection3Subsection5Url",
					attrDictionaryKey:
						"HeaderSection3Subsection5TitleAttribute",
					eventID: null,
				},
				{
					labelDictionaryKey: "HeaderSection3Subsection6Text",
					linkDictionaryKey: "HeaderSection3Subsection6Url",
					attrDictionaryKey:
						"HeaderSection3Subsection6TitleAttribute",
					eventID: null,
				},
				{
					labelDictionaryKey: "HeaderSection3Subsection7Text",
					linkDictionaryKey: "HeaderSection3Subsection7Url",
					attrDictionaryKey:
						"HeaderSection3Subsection7TitleAttribute",
					eventID: null,
				},
				{
					labelDictionaryKey: "HeaderSection3Subsection8Text",
					linkDictionaryKey: "HeaderSection3Subsection8Url",
					attrDictionaryKey:
						"HeaderSection3Subsection8TitleAttribute",
					eventID: null,
				},
				{
					labelDictionaryKey: "HeaderSection3Subsection9Text",
					linkDictionaryKey: "HeaderSection3Subsection9Url",
					attrDictionaryKey:
						"HeaderSection3Subsection9TitleAttribute",
					eventID: null,
				},
				{
					labelDictionaryKey: "HeaderTextRandomWordGenerator",
					linkDictionaryKey: "HeaderUrlRandomWordGenerator",
					attrDictionaryKey:
						"HeaderTitleAttributeRandomWordGenerator",
					eventID: null,
				},
			],
			[
				{
					labelDictionaryKey: "HeaderTextSpellingBee",
					linkDictionaryKey: "HeaderUrlSpellingBee",
					attrDictionaryKey: "HeaderTitleAttributeSpellingBee",
					eventID: null,
				},
				{
					labelDictionaryKey: "HeaderTextWordleHints",
					linkDictionaryKey: "HeaderUrlWordleHints",
					attrDictionaryKey: "HeaderTitleAttributeWordleHints",
					eventID: null,
				},
				{
					labelDictionaryKey: "HeaderTextContexto",
					linkDictionaryKey: "HeaderUrlContexto",
					attrDictionaryKey: "HeaderTitleAttributeContexto",
					eventID: null,
				},
				{
					labelDictionaryKey: "HeaderSection3Subsection13Text",
					linkDictionaryKey: "HeaderSection3Subsection13Url",
					attrDictionaryKey:
						"HeaderSection3Subsection13TitleAttribute",
					eventID: null,
				},
			],
		],
	},
	{
		labelDictionaryKey: "HeaderSection4Text",
		linkDictionaryKey: null,
		attrDictionaryKey: "HeaderSection4TitleAttribute",
		navLink: true,
		eventID: null,
		submenu: [
			[
				{
					labelDictionaryKey: "HeaderSection4Subsection1Text",
					linkDictionaryKey: "HeaderSection4Subsection1Url",
					attrDictionaryKey:
						"HeaderSection4Subsection1TitleAttribute",
					eventID: null,
				},
				{
					labelDictionaryKey: "HeaderSection4Subsection2Text",
					linkDictionaryKey: "HeaderSection4Subsection2Url",
					attrDictionaryKey:
						"HeaderSection4Subsection2TitleAttribute",
					eventID: null,
				},
				{
					labelDictionaryKey: "HeaderSection4Subsection3Text",
					linkDictionaryKey: "HeaderSection4Subsection3Url",
					attrDictionaryKey:
						"HeaderSection4Subsection3TitleAttribute",
					eventID: null,
				},
				{
					labelDictionaryKey: "HeaderSection4Subsection4Text",
					linkDictionaryKey: "HeaderSection4Subsection4Url",
					attrDictionaryKey:
						"HeaderSection4Subsection4TitleAttribute",
					eventID: null,
				},
				{
					labelDictionaryKey: "HeaderTextFiveLetterWords",
					linkDictionaryKey: "HeaderUrlFiveLetterWords",
					attrDictionaryKey: "HeaderTitleAttributeFiveLetterWords",
					eventID: null,
				},
			],
			[
				{
					labelDictionaryKey: "HeaderSection4Subsection5Text",
					linkDictionaryKey: "HeaderSection4Subsection5Url",
					attrDictionaryKey:
						"HeaderSection4Subsection5TitleAttribute",
					eventID: null,
				},
				{
					labelDictionaryKey: "HeaderSection4Subsection6Text",
					linkDictionaryKey: "HeaderSection4Subsection6Url",
					attrDictionaryKey:
						"HeaderSection4Subsection6TitleAttribute",
					eventID: null,
				},
				{
					labelDictionaryKey: "HeaderSection4Subsection7Text",
					linkDictionaryKey: "HeaderSection4Subsection7Url",
					attrDictionaryKey:
						"HeaderSection4Subsection7TitleAttribute",
					eventID: null,
				},
				{
					labelDictionaryKey: "HeaderSection4Subsection8Text",
					linkDictionaryKey: "HeaderSection4Subsection8Url",
					attrDictionaryKey:
						"HeaderSection4Subsection8TitleAttribute",
					eventID: null,
				},
				{
					labelDictionaryKey: "HeaderSection4Subsection9Text",
					linkDictionaryKey: "HeaderSection4Subsection9Url",
					attrDictionaryKey:
						"HeaderSection4Subsection9TitleAttribute",
					eventID: null,
				},
			],
			[
				{
					labelDictionaryKey: "HeaderSection4Subsection10Text",
					linkDictionaryKey: "HeaderSection4Subsection10Url",
					attrDictionaryKey:
						"HeaderSection4Subsection10TitleAttribute",
					eventID: null,
				},
				{
					labelDictionaryKey: "HeaderSection4Subsection11Text",
					linkDictionaryKey: "HeaderSection4Subsection11Url",
					attrDictionaryKey:
						"HeaderSection4Subsection11TitleAttribute",
					eventID: null,
				},
				{
					labelDictionaryKey: "HeaderSection4Subsection12Text",
					linkDictionaryKey: "HeaderSection4Subsection12Url",
					attrDictionaryKey:
						"HeaderSection4Subsection12TitleAttribute",
					eventID: null,
				},
			],
		],
	},
	{
		labelDictionaryKey: "HeaderSection5Text",
		linkDictionaryKey: "HeaderSection5Url",
		attrDictionaryKey: "HeaderSection5TitleAttribute",
		useRouter: true,
		navLink: true,
		eventID: null,
	},
	{
		labelDictionaryKey: "HeaderSection6Text",
		linkDictionaryKey: "HeaderSection6Url",
		attrDictionaryKey: "HeaderSection6TitleAttribute",
		useRouter: true,
		navLink: true,
		eventID: null,
		cssClass: "mobile-only",
	},
	{
		accountButtons: true,
		cssClass: "buttons-item",
	},
	{
		imageUrl: "/static-wf/images/ic_yd_wordscapes.png",
		imageUrlWebp: "/static-wf/images/ic_yd_wordscapes.webp",
		labelDictionaryKey: "Wordscapes",
		mobileLabel: "Wordscapes Answers and Cheat",
		linkDictionaryKey: "HeaderSectionUrlWordscapes",
		attrDictionaryKey: "HeaderSectionTitleAttributeWordscapes",
		altTextDictionaryKey: "HeaderSectionTextWordscapes",
		ariaLabelDictionaryKey: "HeaderSectionAriaLabelWordscapes",
		navLink: true,
		cssClass: "other-links-start",
		gaEventLabel: "Wordscapes Logo",
		eventID: 9,
	},
	{
		imageUrl: "/static-wf/images/ic_wfw_header.png",
		imageUrlWebp: "/static-wf/images/ic_wfw_header.webp",
		labelDictionaryKey: "EsWfLogoText",
		mobileLabel: "Spanish WordFinder",
		linkDictionaryKey: "EsWfLogoUrl",
		attrDictionaryKey: "EsWfLogoTitleAttribute",
		altTextDictionaryKey: "EsWfLogoAltText",
		ariaLabelDictionaryKey: "EsWfLogoAriaLabel",
		navLink: true,
		cssClass: "mobile-only",
		gaEventLabel: "ES WF Logo",
		gaEventAction: "ES WF Logo",
		eventID: 3,
	},
	{
		imageUrl: "/static-wf/images/ic_ydr_header.png",
		imageUrlWebp: "/static-wf/images/ic_ydr_header.webp",
		labelDictionaryKey: "YdrLogoText",
		mobileLabel: "YourDictionary",
		linkDictionaryKey: "HeaderYdrUrl",
		attrDictionaryKey: "HeaderYdrTitleAttribute",
		altTextDictionaryKey: "HeaderYdrLogoAltText",
		ariaLabelDictionaryKey: "HeaderYdrAriaLabel",
		navLink: true,
		cssClass: "mobile-only",
		gaEventLabel: "YDR Logo",
		gaEventAction: "YDR Logo",
		eventID: 11,
	},
];
